import React, { useEffect, useState, useCallback, useMemo, useContext } from "react";
import PropTypes from "prop-types";
import jwt from "jsonwebtoken";
import OfficeSharedService from "../services/OfficeSharedService";
import AppContext from "../app/AppContext";
import AppWord from "./word/AppWord";
import AppPowerPoint from "./powerpoint/AppPowerPoint";
import AppLegacy from "./AppLegacy";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../authConfigAzureAd";
import ApiService from "../services/ApiService";

const msalInstance = new PublicClientApplication(msalConfig);
const authType = window["APP_SETTINGS"].AUTH_TYPE;

const App = ({ isOfficeInitialized }) => {
  const context = useContext(AppContext);
  const [currentOfficeAppType, setCurrentOfficeAppType] = useState("");

  const authAzureAd = async () => {
    console.log("App.js Aquiring access token -->");
    await msalInstance.initialize();
    const accounts = await msalInstance.getAllAccounts();
    console.log("App.js accounts", accounts);
    if (accounts.length > 0) {
      console.log("App.js accounts.length > 0");
      const request = {
        ...loginRequest,
        account: accounts[0]
      };
      await reAuthenticateAuthAzureAd(request);
    }
  };

  const reAuthenticateAuthAzureAd = async (request) => {
    console.log("App.js authAzureAd -->")
    await msalInstance
      .acquireTokenSilent(request)
      .then(async(response) => {
        console.log(response);
        console.log("App.js authAzureAd ID Token:", response.idToken);
        console.log("App.js authAzureAd Access Token:", response.accessToken);

        let accessToken = response.accessToken || "";
        let userJWT = jwt.decode(accessToken);
        let username = response.account?.username || userJWT.preferred_username || userJWT.upn || userJWT.unique_name || "";
        let tenantId = response.tenantId || userJWT.tid || "";
        let graphConnectorId = response.idTokenClaims?.aud || userJWT.aud || userJWT.appid || "";
        let currDateOffset = new Date().getTimezoneOffset();

        let data = {
          username: username,
          tenantId: tenantId,
          graphConnectorId: graphConnectorId,
          graphToken: accessToken,
          timezone: currDateOffset,
        };

        await ApiService.azureUserLogin(data, context).then(
          (result) => {
            if (result.status === 200) {
              console.log("API [azureUserLogin] -> status 200");
              if (result.data.Token != null) {
                console.log("App.js [AzureUserLogin] result -->");
                console.log(result);

                console.log("App.js [AzureUserLogin] set context variables -->");
                localStorage.setItem("tmpTriyoToken", result.data.Token);
                localStorage.setItem("tmpJwtTriyoToken", result.data.AccessToken);
                context.userToken = result.data.Token ?? "";
                context.jwtUserToken = result.data.AccessToken ?? "";
                context.graphUserToken = result.data.GraphToken ?? "";
                context.currUser = result.data.User ?? "";
                context.userName = result.data.User.UserName ?? "";
                context.userNameFull = result.data.User.Name ?? "";
                context.userEmail = result.data.User.Email ?? "";
                context.userLogin = true;
                context.tokenReady = true;
                console.log("AzureUserLogin => context.tokenReady", context.tokenReady);
              } else {
                throw new Error("[AzureUserLogin]: Token was not received");
              }
            } else {
              console.log("API [azureUserLogin] -> status: " + result.status);
              throw new Error("[AzureUserLogin]: API call failed with status " + result.status);
            }
          },
          (error) => {
            console.log("AppRender.js AzureUserLogin [error]: ");
            console.log(error);
          }
        );
      })
      .catch(error => {
        if (error.errorMessage.includes("interaction_required")) {
          msalInstance.acquireTokenRedirect(request);
        } else {
          console.log("App.js authAzureAd Access token error -->");
          console.error(error);
        }
      });
  };

  useEffect(() => {
    console.log("[0] App.js - useEffect => Started");
    const OfficeSharedServiceResult = OfficeSharedService.getAppType(Office.context);

    if (OfficeSharedServiceResult !== "") {
      console.log("[0.1] App.js - useEffect => [OfficeSharedServiceResult] completed: ", OfficeSharedServiceResult);
      context.officeAppType = OfficeSharedServiceResult;
      setCurrentOfficeAppType(OfficeSharedServiceResult);
      if (OfficeSharedServiceResult == "Word") context.officeAppTypeDoc = 1;
      else if (OfficeSharedServiceResult == "PowerPoint") context.officeAppTypeDoc = 3;
      else if (OfficeSharedServiceResult == "Outlook") context.officeAppTypeDoc = 4;
    }

    if (authType === "AzureAD") {
      console.log("App.js Auth Type AzureAD");
      let userToken = localStorage.getItem("tmpTriyoToken");
      let graphToken = "";

      if (!userToken || userToken == "") {
        console.log("App.js No this.context.userToken Value calling authAzureAd -->");
        authAzureAd();
        return;
      } else {
        console.log("GetGraphTokenByToken =>");
        try {
          let data = {
            token: userToken,
            graphToken: "",
          };

          ApiService.getGraphTokenByToken(data, context)
            .then((result) => {
              if (result.status !== 200) {
                console.error("App.js GetGraphTokenByToken failed with status:", result.status);
                authAzureAd();
              } else if (result.data && result.data.error) {
                console.error("App.js GetGraphTokenByToken error:", result.data.error);
                authAzureAd();
                return;
              } else {
                console.log("App.js GetGraphTokenByToken success -->", result.data);
                graphToken = result.data;

                if (!graphToken || graphToken == "") {
                  console.log("App.js No this.context.graphToken Value calling authAzureAd -->");
                  authAzureAd();
                  return;
                } else {
                  console.log("App.js this.context.graphToken decodedToken Value -->");
                  const decodedToken = JSON.parse(atob(graphToken.split(".")[1]));
                  console.log(decodedToken);
                  const currentTime = Date.now() / 1000;
                  if (decodedToken.exp > currentTime) {
                    console.log("App.js Token Not Expired -->");
                    context.userToken = userToken;
                    //context.jwtUserToken = userToken;
                    context.graphUserToken = graphToken;

                    // This is just to check the token is working for graph endpoints. Will be removed later. Keep it for now.
                    const graphResponse = fetch("https://graph.microsoft.com/v1.0/me", {
                      headers: {
                        Authorization: `Bearer ${graphToken}`
                      }
                    });
                    console.log("App.js Graph Profile Data -->");
                    console.log(graphResponse);

                    ApiService.getCurrentUser(context)
                      .then(result => {
                        console.log(result);
                        if (result.status === 200) {
                          if (result.data.User.Active === false) {
                            console.log("API [ApiDataService.login] User Account is not Active -->");
                            return;
                          }
                          context.currUser = result.data.User;
                          context.userName = result.data.User.UserName;
                          context.userNameFull = result.data.User.Name;
                          context.userEmail = result.data.User.Email;
                          context.userLogin = true;
                          context.tokenReady = true;
                          console.log("getCurrentUser => context.tokenReady", context.tokenReady);
                        } else {
                          console.log("API [ApiDataService.login] error status: " + result.status);
                        }
                      })
                      .catch(error => {
                        console.log("API [ApiDataService.login] error ->");
                        console.log(error);
                      });
                  } else {
                    console.log("App.js Token Expired -->");
                    authAzureAd();
                    return;
                  }
                }
              }
            })
            .catch((error) => {
              console.error("App.js GetGraphTokenByToken error:", error);
              authAzureAd();
            });
        } catch (err) {
          console.log('GetGraphTokenByToken:', err);
          authAzureAd();
          return;
        }
      }
    } else {
      // Other auth types
    }
  }, []);

  useEffect(() => {
    console.log("[0.2] App.js - useEffect => State changes detected...");
  }, [currentOfficeAppType]);

  return (
    <div>
      {currentOfficeAppType == "Word" && <AppWord />}
      {currentOfficeAppType == "PowerPoint" && <AppPowerPoint isOfficeInitialized={isOfficeInitialized} />}
      {currentOfficeAppType == "Outlook" && <AppLegacy />}
    </div>
  );
};

App.propTypes = {
  isOfficeInitialized: PropTypes.bool.isRequired
};

export default App;

// Components to be decoupled and unit-tested later:
// - AppOutlookDesktop.js
// - AppOutlookPWA.js
//
// Code:
// import AppOutlookDesktop from "./outlook/AppOutlookDesktop";
// import AppOutlookPWA from "./outlook/AppOutlookPWA";
//
// { currentOfficeAppType == "Outlook" && <AppOutlookDesktop /> }
// { currentOfficeAppType == "OutlookPWA" && <AppOutlookPWA /> }
// { currentOfficeAppType == "" && <AppLegacy /> }
//
// Note: AppLegacy, AppOutlookPWA, and AppOutlook are exact copy of the
// original App.js and remain unchanged
